export default __webpack_public_path__ + "static/media/circle-chevron-bottom.ae171dd9.svg";